import * as types from "./types";
import * as actions from "./actions";

import { apiCall, GET_DIVISION_URL } from "apis";

import { persistState } from "state/modules/root";
import { setSubmittedCount } from "state/modules/taker";

import { DivisionDeserializer } from "serializers";

export const setBenchmarkAchieved = actions.setBenchmarkAchieved;

export const getDivision = () => async (dispatch, getState) => {
  const state = getState();
  const { organization, feedback, taker } = state;
  await dispatch(
    apiCall({
      type: types.GET_DIVISION,
      payload: {
        url: GET_DIVISION_URL(
          organization.id,
          taker.divisionId,
          feedback.group.id,
          taker.id,
        ),
        transform: DivisionDeserializer,
        onSuccess: setDivision,
        onDisconnected: () => {},
      },
    }),
  );
};

export const setDivision = division => dispatch => {
  dispatch(setSubmittedCount(division.taker_count));
  dispatch(actions.setDivision(division));
  dispatch(persistState());
};
